'use client';
import { Game } from '@/types';
import { LanguageCode } from '@/lib/games';
import { translations } from '@/lib/translations';

interface GameplayGuideProps {
  game: Game;
  lang: LanguageCode;
}

export default function GameplayGuide({ game, lang }: GameplayGuideProps) {
  if (!game) return null;

  return (
    <section className="bg-white/80 rounded-lg shadow-md p-6 mb-8">
      <h2 className="text-3xl font-bold mb-4 gradient-text">
        {translations.gameplayGuide.title[lang]} {game.title}
      </h2>
      <div className="space-y-6">
        <div className="bg-purple-50 p-6 rounded-lg">
          <h3 className="text-2xl font-semibold mb-4 text-purple-600">
            {translations.gameplayGuide.removeBlocks[lang]}
          </h3>
          <p className="text-gray-700">
            {game.howToPlay}
          </p>
        </div>
      </div>
    </section>
  );
}